import { css } from "@emotion/core";
import {
  color,
  fontWeight,
  fontSizes,
  fontTypes,
} from "../../constants/commons";
export const preliminaryQuizStyle = css`
  .download-style {
    color: ${color.darkRed};
    font-family: ${fontTypes.bold};
    font-size: ${fontSizes.xs};
    font-weight: ${fontWeight.medium};
    text-align: right;
    text-transform: uppercase;
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
    .responsive-pdf-thumbnail {
      width: 8%;
      border-radius: 0.3125em;
    }
  }
  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
    .responsive-pdf-thumbnail {
      width: 6%;
      border-radius: 0.3125em;
    }
  }
  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
    .responsive-pdf-thumbnail {
      width: 7%;
      border-radius: 0.3125em;
    }
  }
  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
    .responsive-pdf-thumbnail {
      width: 5%;
      border-radius: 0.3125em;
    }
  }
  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
    .responsive-pdf-thumbnail {
      width: 3%;
      border-radius: 0.3125em;
    }
  }
`;
